import { z } from 'zod';
import { IdSchema, TimestampSchema } from './common.js';

export const AuditEntityTypeSchema = z.enum(['topic', 'document', 'brand_voice']);
export type AuditEntityType = z.infer<typeof AuditEntityTypeSchema>;

export const AuditActionSchema = z.enum(['create', 'update', 'delete']);
export type AuditAction = z.infer<typeof AuditActionSchema>;

export const ContentChangeSchema = z.object({
  id: IdSchema,
  userId: IdSchema,
  entityType: AuditEntityTypeSchema,
  entityId: IdSchema,
  action: AuditActionSchema,
  diff: z.unknown(),
  createdAt: TimestampSchema,
});
export type ContentChange = z.infer<typeof ContentChangeSchema>;

export const ListAuditQuerySchema = z.object({
  entityType: AuditEntityTypeSchema.optional(),
  userId: IdSchema.optional(),
  cursor: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(100).default(50),
});
export type ListAuditQuery = z.infer<typeof ListAuditQuerySchema>;
